import script from "./PaginationBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationBox.vue?vue&type=script&setup=true&lang=js"

import "./PaginationBox.vue?vue&type=style&index=0&id=2747a63a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2747a63a"]])

export default __exports__